module.exports = __webpack_public_path__ + "img/AlegeusCard.0c433c6a.png";